import { isNumber } from 'lodash';
import {
  RecomendacaoSemeaduraFormValues,
  RecomendacaoSemeaduraStatusType,
} from '../../../@types';
import makeForm from '../../../components/Form';
import Yup from '../../../utils/yup';

const requiredIfNoSementeCobertura = <T extends any>(schema: Yup.Schema<T>) =>
  schema.when('sementeCobertura', { is: false, then: (s) => s.required() });

export const validationSchema = Yup.object().shape({
  status: Yup.string().required(),
  situacao: Yup.string().required(),
  propriedade: Yup.object().required(),
  safra: Yup.object().required(),
  periodo: Yup.object().when('status', {
    is: (status: RecomendacaoSemeaduraStatusType | undefined) =>
      status === 'rascunho',
    then: (schema) => schema.notRequired(),
    otherwise: (schema) => schema.required(),
  }),
  atividade: Yup.object().required(),
  rendimentoOperacionalMinimo: Yup.number().min(0).required(),
  rendimentoOperacionalMaximo: Yup.number()
    .min(0)
    .when('rendimentoOperacionalMinimo', {
      is: isNumber,
      then: (schema) => schema.min(Yup.ref('rendimentoOperacionalMinimo')),
    })
    .required(),
  espacamento: requiredIfNoSementeCobertura(Yup.number().min(0)),
  porcentagemAreaRemonte: requiredIfNoSementeCobertura(Yup.number().min(0)),
  porcentagemCorrecaoDensidade: requiredIfNoSementeCobertura(
    Yup.number().min(0),
  ),
  porcentagemCorrecaoQuantidade: requiredIfNoSementeCobertura(
    Yup.number().min(0),
  ),
  distribuicaoRegulagemSemente: requiredIfNoSementeCobertura(
    Yup.number().min(0),
  ),
  distribuicaoRegulagemAdubo: requiredIfNoSementeCobertura(Yup.number().min(0)),
  descricao: Yup.string(),
  clienteAgrogestao: Yup.boolean().nullable(),
  sementeCobertura: Yup.boolean().default(false),
  observacoes: Yup.string().optional(),
  talhoes: Yup.array().min(1),
});

export const defaultValues: RecomendacaoSemeaduraFormValues = {
  sementeCobertura: false,
  clienteAgrogestao: false,
  propriedade: undefined,
  safra: undefined,
  periodo: undefined,
  atividade: undefined,
  rendimentoOperacionalMinimo: undefined,
  rendimentoOperacionalMaximo: undefined,
  espacamento: undefined,
  porcentagemAreaRemonte: undefined,
  porcentagemCorrecaoDensidade: undefined,
  porcentagemCorrecaoQuantidade: undefined,
  distribuicaoRegulagemSemente: undefined,
  distribuicaoRegulagemAdubo: undefined,
  comMargemSeguranca: false,
  observacoes: '',
  talhoes: [],
  adubos: [],
  status: undefined,
  situacao: undefined,
};

export const Form = makeForm<RecomendacaoSemeaduraFormValues>();
